import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
  hasUnsavedChanges?: boolean;
  showUnsavedChangesModal?: boolean;
  navigateWithCheck?: (callback: () => void) => void;
}

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    // Si el componente tiene cambios sin guardar
    if (component.hasUnsavedChanges) {
      // Mostrar modal de confirmación
      return new Promise<boolean>((resolve) => {
        if (component.navigateWithCheck) {
          component.navigateWithCheck(() => {
            resolve(true); // Permitir navegación después de confirmar
          });
        } else {
          // Fallback: usar confirm nativo del navegador
          const result = confirm('Tienes cambios sin guardar. ¿Estás seguro de que quieres salir?');
          resolve(result);
        }
      });
    }
    
    // Si no hay cambios sin guardar, permitir navegación
    return true;
  }
} 